import { atom } from "recoil";
import ProgramModel from "../Models/program.model";

export const ProgramAtom = atom({
  key: "ProgramAtom",
  default: new ProgramModel(),
});
